import React from "react";
import { AGEING_TONES } from "./avShared";

// A loud, scannable ageing pill. Big number, colour-coded chip, optional
// "working days" hint. Reused across the AV workbench cards and the detail
// page header.
export const AgeingBadge = ({ bucket = "green", days = 0, label = "Ageing", showDot = true, size = "md" }) => {
  const t = AGEING_TONES[bucket] || AGEING_TONES.green;
  const sizes = {
    sm: { wrap: "px-2 py-0.5 text-[11px]", num: "text-[12px]", dot: "w-1.5 h-1.5" },
    md: { wrap: "px-3 py-1 text-[11.5px]", num: "text-[15px]", dot: "w-2 h-2" },
    lg: { wrap: "px-4 py-2 text-[12px]", num: "text-[28px]", dot: "w-2.5 h-2.5" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border ${t.bg} ${t.border} ${s.wrap}`}
      data-testid={`av-ageing-${bucket}`}
    >
      {showDot && <span className={`${s.dot} rounded-full ${t.dot}`} />}
      <span className="uppercase tracking-wider font-semibold text-[#444653]">{label}</span>
      <span className={`${s.num} font-bold ${t.text}`}>
        {days}
        <span className="ml-1 text-[10.5px] font-semibold opacity-80">d</span>
      </span>
    </div>
  );
};

export default AgeingBadge;
